import { useState } from "react";
import { Button, Card } from "../../../../shared";
import { CustomerCsvImportModal } from "../../../Clients/CustomerCsvImportModal";
import { useImportAdminCustomerCsvMutation } from "../../../../redux/services/admin/adminApi";
import { formatDate } from "../../../../utils";

const renderImportDate = (value) => {
  if (!value) return "Unknown";
  try {
    return formatDate(value);
  } catch (_error) {
    return String(value);
  }
};

const DataIntegrationTab = ({ customer }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [importAdminCustomerCsv] = useImportAdminCustomerCsvMutation();
  const importHistory = Array.isArray(customer?.metadata?.importHistory)
    ? customer.metadata.importHistory
    : [];

  return (
    <div className="space-y-6">
      <Card>
        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <div>
            <h3 className="text-lg font-medium">Data Integration</h3>
            <p className="text-sm text-gray-500 mt-1">
              Import onboarding CSV data into jobs, clients, locations, and
              employees/drivers for this tenant.
            </p>
          </div>
          <Button onClick={() => setModalVisible(true)} disabled={!customer?._id}>
            Upload CSV Data
          </Button>
        </div>
      </Card>

      <Card>
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-medium">Past Uploads</h3>
          <span className="text-sm text-gray-500">{importHistory.length} records</span>
        </div>
        {importHistory.length === 0 ? (
          <p className="text-sm text-gray-500">
            No data imports have been recorded for this customer yet.
          </p>
        ) : (
          <div className="space-y-3">
            {importHistory.map((item, index) => (
              <div
                key={`${item?.importedAt || "import"}-${index}`}
                className="rounded-md border border-gray-200 p-3 bg-white"
              >
                <div className="flex flex-col gap-1 md:flex-row md:items-center md:justify-between">
                  <div className="font-medium text-gray-900">
                    {(item?.entity || "unknown").replace(/_/g, " ")}
                  </div>
                  <div className="text-xs text-gray-500">
                    {renderImportDate(item?.importedAt)}
                  </div>
                </div>
                <div className="mt-2 grid grid-cols-2 md:grid-cols-5 gap-2 text-xs text-gray-600">
                  <div>File: {item?.fileName || "Unknown"}</div>
                  <div>Rows: {item?.totalRows ?? "-"}</div>
                  <div>Created: {item?.summary?.created ?? 0}</div>
                  <div>Updated: {item?.summary?.updated ?? 0}</div>
                  <div>Skipped: {item?.summary?.skipped ?? 0}</div>
                </div>
                <div className="mt-2 text-xs text-gray-500">
                  By: {item?.importedBy?.name || item?.importedBy?.email || "Unknown user"}
                </div>
                <div className="mt-1 text-xs text-gray-500">
                  Metadata keys:{" "}
                  {Object.keys(item?.savedMetadata || {}).length > 0
                    ? Object.keys(item.savedMetadata).join(", ")
                    : "None"}
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>

      <CustomerCsvImportModal
        visible={modalVisible}
        setVisible={setModalVisible}
        customerId={customer?._id}
        title={`Import Data: ${customer?.name || "Customer"}`}
        importAction={(payload) =>
          importAdminCustomerCsv({
            id: customer?._id,
            ...payload,
          })
        }
      />
    </div>
  );
};

export default DataIntegrationTab;
